import * as fromLOADING from './loading.actions';

export interface State {
	isLoading: boolean;
}

const initState: State = {
	isLoading: false
};

export function uiReducer(State = initState, action: fromLOADING.acciones): State {
	switch (action.type) {
		case fromLOADING.ACTIVAR_LOADING:
			return { isLoading: true };
		case fromLOADING.DESACTIVAR_LOADING:
			return { isLoading: false };
		default:
			return initState;
	}
}